import {
  requestGet as wsRequestGet,
} from "./_wsApiFetchData";

export async function getExternalActivity(id, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/externalactivity/${id}`, language, timeZone, null, cancelToken);
}
